import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useEvent } from "../../layouts/EventLayout";
import { EventForm } from "./EventForm";

export function EventEditPage() {
  const { event, loading, refetch } = useEvent();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!event) {
    return (
      <Typography color="text.secondary">Event not found.</Typography>
    );
  }

  return <EventForm mode="edit" initialData={event} onSaved={refetch} />;
}
